import Page from 'src/showcase/[entityId]/embed/index';

export default Page;
